import { Location } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { IThankingPopupInputs } from '@shared/interfaces';

@Component({
  selector: 'el-thanking-popup',
  templateUrl: './thanking-popup.component.html',
  styleUrls: ['./thanking-popup.component.scss'],
})
export class ThankingPopupComponent {
  constructor(
    private location: Location,
    private dialogRef: MatDialogRef<ThankingPopupComponent>,
    public translate: TranslateService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: IThankingPopupInputs
  ) {}
  onReturn() {
    this.router.navigate(['']);
    this.dialogRef.close();
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
